/* eslint-disable max-len */
import { SplitIcon, WarningWithTooltip, OriginalCurrencyComponent } from './sharedComponents';

export const stocksTransactions = {
  columnParams:
    'grid-cols-[4fr,2fr,2fr,1fr] sm:grid-cols-[20%,minmax(0,1fr),minmax(0,1fr),minmax(0,2fr),minmax(0,2fr),minmax(0,1fr),minmax(0,1fr)] md:grid-cols-[20%,1fr,4fr,4fr,2fr,2fr,1fr] lg:grid-cols-[30%,2fr,4fr,4fr,2fr,2fr,3rem]',
  columns: [
    [
      // prettier-ignore
      {
        ifSummaryRowDisplay: false, id: 'date', type: 'date', textAlign: 'text-left', classNamesBoth: 'text-xs sm:text-sm flex gap-1 items-align', displayElement: { field: 'itemHasFlag', element: WarningWithTooltip },
        // ^^ need this for both columns
      },
      // prettier-ignore
      {
        ifSummaryRowDisplay: false, id: 'openPositionSize', type: 'number0Decimals', classNamesBody: 'text-xs text-gray-400 font-normal', classNamesBoth: 'sm:hidden', displayElement: { field: 'isPreSplitTransaction', element: SplitIcon }, hideHeaderLabel: true,
      },
      // prettier-ignore
      {
        ifSummaryRowDisplay: true, id: 'displayName', type: 'string', textAlign: 'text-left', classNamesBoth: 'text-xs sm:text-sm', ifSummaryRowClassNames: 'text-brandBlue-600 truncate',
      },
      // prettier-ignore
      {
        ifSummaryRowDisplay: true, id: 'openPositionSize', type: 'number0Decimals', classNamesBody: 'text-xs text-gray-400 font-normal', classNamesBoth: 'hidden', displayElement: { field: 'isPreSplitTransaction', element: SplitIcon }, hideHeaderLabel: true,
      },
    ],
    [
      // prettier-ignore
      {
        id: 'openPositionSize', type: 'number0Decimals', classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'hidden sm:block', displayElement: { field: 'isPreSplitTransaction', element: SplitIcon },
      },
      { id: 'currentValueBaseCurrency', usesHeader: 'currentValue', type: 'currency', classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'sm:hidden' },
      { id: 'purchaseValue', usesHeader: 'purchaseValueFull', type: 'currency', classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'sm:hidden' },
    ],
    [
      { id: 'purchaseValue', usesHeader: 'purchaseValueFull', type: 'currency', classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'hidden sm:block' },
      {
        id: 'transactionPrice',
        type: 'currency',
        classNamesBody: 'text-xs text-gray-400',
        classNamesBoth: 'hidden sm:block',
        displayElement: { field: 'displayPriceTransactionCurrency', element: OriginalCurrencyComponent },
      },
    ],
    [
      { id: 'currentValueBaseCurrency', usesHeader: 'currentValue', type: 'currency', classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'hidden sm:block' },
      {
        id: 'currentQuoteBaseCurrency',
        usesHeader: 'currentPrice',
        type: 'currency',
        classNamesBody: 'text-xs text-gray-400',
        classNamesBoth: 'hidden sm:block',
        displayElement: { field: 'displayQuoteTransactionCurrency', element: OriginalCurrencyComponent },
      },
      { id: 'dividendsSincePurchase', type: 'currency', classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'sm:hidden' },
      { id: 'fees', type: 'currency', hideHeaderLabel: true, classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'sm:hidden' },
    ],
    [
      { id: 'dividendsSincePurchase', type: 'currency', classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'hidden sm:block' },
      { id: 'fees', type: 'currency', hideHeaderLabel: true, classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'hidden sm:block' },
    ],
    [
      { id: 'roi', type: 'percentage', usesHeader: 'roiOnly', classNamesBody: 'text-xs sm:text-sm', classNamesBoth: 'hidden sm:block' },
      { id: 'roiAnnual', type: 'percentage', classNamesBody: 'text-xs text-gray-400', classNamesBoth: 'hidden sm:block' },
    ],
    [
      // prettier-ignore
      {
        ifSummaryRowDisplay: false, id: 'ellipsis', type: 'ellipsis', usesHeader: 'emptyString', classNamesBody: '-ml-3',
      },
      // prettier-ignore
      {
        ifSummaryRowDisplay: true, id: 'bn', type: 'number0Decimals', hideHeaderLabel: true, displayElement: { field: 'itemHasFlag', element: WarningWithTooltip },
      },
    ],
  ],
};

export const stocksTransactionsReport = {
  columnParams: 'grid-cols-[2fr,1fr,1fr,1fr,1fr,1fr]',
  columns: [
    [
      { ifSummaryRowDisplay: false, id: 'date', type: 'date', textAlign: 'text-left', classNamesBoth: 'text-xs sm:text-sm' },
      // ^^ need this for both types of row

      { ifSummaryRowDisplay: false, id: 'accountName', type: 'string', textAlign: 'text-left', classNamesHeader: 'text-xs sm:text-sm', classNamesBody: 'text-xs text-gray-400 uppercase' },

      { ifSummaryRowDisplay: true, id: 'displayName', type: 'string', textAlign: 'text-left', classNamesBoth: 'text-xs sm:text-sm', ifSummaryRowclassNames: 'text-brandBlue-600' },
    ],
    [{ id: 'openPositionSize', type: 'number0Decimals', classNamesBody: 'text-xs sm:text-sm', displayElement: { field: 'isPreSplitTransaction', element: SplitIcon } }],
    [
      { id: 'purchaseValue', type: 'currency', classNamesBody: 'text-xs sm:text-sm' },

      { id: 'transactionPrice', type: 'currency', classNamesBody: 'text-xs text-gray-400' },
    ],
    [
      { id: 'currentValueBaseCurrency', usesHeader: 'currentValue', type: 'currency', classNamesBody: 'text-xs sm:text-sm' },

      { id: 'currentQuoteBaseCurrency', usesHeader: 'currentPrice', type: 'currency', classNamesBody: 'text-xs text-gray-400', hideHeaderLabel: true },
    ],
    [
      { id: 'dividendsSincePurchase', type: 'currency', classNamesBody: 'text-xs sm:text-sm' },

      { id: 'fees', type: 'currency', hideHeaderLabel: true, classNamesBody: 'text-xs sm:text-sm' },
    ],
    [
      { id: 'roi', type: 'percentage', usesHeader: 'roiOnly', classNamesBody: 'text-xs sm:text-sm' },

      { id: 'roiAnnual', type: 'percentage', classNamesBody: 'text-xs text-gray-400' },
    ],
  ],
};

export const stocksQuotes = {
  // minmax(0,...) to disregard the content width when calculating the column width
  columnParams: 'grid-cols-[minmax(0,2fr),minmax(0,2fr),minmax(0,2fr),minmax(0,2fr)] md:grid-cols-[minmax(0,2fr),minmax(0,2fr),minmax(0,2fr),minmax(0,1fr),30%] xl:grid-cols-[2fr,2fr,2fr,1fr,50%]',
  columns: [
    [
      {
        id: 'date',
        type: 'date',
        textAlign: 'text-left', // textAlign on item[0] determines alignment on the whole column and the HTML id of the entire cell
      },
    ],
    [{ id: 'quoteBaseCurrency', usesHeader: 'price', type: 'currency' }],
    [
      { id: 'quote', usesHeader: 'originalPrice', type: 'number' },
      { id: 'currency', type: 'string', classNamesBoth: 'md:hidden' },
    ],
    [{ id: 'currency', type: 'string', classNamesBoth: 'hidden md:inline' }],
    [{ id: 'note', type: 'string' }],
  ],
};
